import {useCallback, useState} from "react";
import {useToast} from "use-toast-mui";
import {AdminAction, User} from "../types";
import {useRetrieveUserInfo} from "./useRetrieveUserInfo";

interface UseExecuteProps {
    user: User | null | undefined;
    setUser: (user: User | null) => void;
}

export const useExecute = ({ user, setUser }: UseExecuteProps) => {
    const toast = useToast();
    const {retrieveUserInfo} = useRetrieveUserInfo();
    const [isLoading, setIsLoading] = useState(false);

    const execute = useCallback(async (callback: AdminAction, key: string | null = null): Promise<void> => {
        const firstKey: string = key ?? user?.keys?.[0]?.value ?? '';
        setIsLoading(true);
        toast.info("Loading...");
        await callback(firstKey);
        const data: User | null = await retrieveUserInfo(firstKey);
        setUser(data);
        setIsLoading(false);
        toast.success('Action completed successfully.');
    }, [retrieveUserInfo, setUser, toast, user?.keys]);

    return {execute, isLoading}
}
